export default "__VITE_ASSET__z_nmOGxG__"